/**
 * Creating a custom ISO string interval to be used in REST API calls.
 *
 * @param {DateInterval} interval
 * @returns {string}
 */
export function intervalToString(interval) {
    const start = interval?.start?.toISOString()
    const end = interval?.end?.toISOString()

    return start && end ? `${start}/${end}` : ''
}
